/*** getActivationFieldsString expects the following data structure
activationFields: [
    {
        id: 5282,
        characteristic: {
            "code": "country",
            "label": "Country"
        },
        characteristicDataType: "text",
        fieldLabel: [
            {
                locale: {
                    code: "en-US",
                    dir: "ltr"
                },
                displayName: "English (United States)",
                cmText: "Country"
            }
        ]
    }
]
*/
export default function getActivationFieldsString( activationFields, locale ) {
    const labels = activationFields.map( field => {
        const labelObject = field.fieldLabel.find( label => label.locale.code === locale );

        // If we can't find a label that matches the selected locale, use en-US
        // as the default.
        if ( labelObject ) {
            return labelObject.cmText;
        } else {
            return ( field.fieldLabel.find( label => label.locale === 'en-US' ) || {} ).cmText;
        }
    } );

    return labels.join( ', ' );
}
